import { Line } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler } from "chart.js";
import { useState } from "react";
import { compactNumber } from "../../screens/dashboard/DashboardCard";

const DashboardLineChart = ({ label, profit, expenses, currency, xAxisLabel }) => {
  const isMobile = window.innerWidth <= 568; // Example breakpoint for mobile devices
  console.log(isMobile, "isMobile");

  const yValue = [...profit, ...expenses].map((val) => Number(val) || 0);
  const maxY = Math.max(0, ...yValue);
  const stepSize = maxY === 0 ? 10 : Math.ceil(maxY / 50);

  ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

  ChartJS.defaults.font.family = "Nunito";
  ChartJS.defaults.font.size = 10;

  //number formatting

  /* const compact = new Intl.NumberFormat("en", {
    notation: "compact", // 1.2K, 3.4M, etc.
    maximumFractionDigits: 1,
  });

  // (optional) for tooltips with currency, full value:
  const money = new Intl.NumberFormat("en", {
    style: "currency",
    currency, // your prop (e.g. "USD", "EUR")
    maximumFractionDigits: 2,
  }); */

  const options = {
    maintainAspectRatio: false,

    plugins: {
      legend: {
        position: "top",
        labels: {
          boxWidth: 16,
        },
        display: false,
      },
      title: {
        display: false,
        text: "Amount of Product Sold",
      },
      tooltip: {
        callbacks: {
          // show full value in tooltip (not compact)
          label: (ctx) => `${ctx.dataset.label.trim()}: ${compactNumber(ctx.parsed.y)}`,
        },
      },
    },
    scales: {
      y: {
        ticks: {
          // compact labels on the axis
          callback: (value) => compactNumber(value),

          stepSize: stepSize,
        },
        title: {
          display: isMobile ? false : true,
          text: "Profit in " + "(" + currency + ")",
        },
        grid: {
          display: false,
          drawBorder: false,
          drawOnChartArea: false,
        },
      },
      x: {
        grid: {
          display: false,
          drawBorder: false,
          drawOnChartArea: false,
        },
        title: {
          display: true,
          text: xAxisLabel /* "Hours (time of the day)" */,
        },
      },
    },
  };

  const labels = label.slice(0, -1);
  const lineToolTip = {
    id: "lineToolTip",
    afterDraw: (chart) => {
      if (chart.tooltip._active && chart.tooltip._active.length) {
        const activePoint = chart.tooltip._active[0];
        const ctx = chart.ctx;
        const x = activePoint.tooltipPosition().x;
        const topY = chart.scales["y"].top;
        const bottomY = chart.scales["y"].bottom;
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(x, topY);
        ctx.lineTo(x, bottomY);
        ctx.lineWidth = 2;
        ctx.strokeStyle = "#0E49B5";
        ctx.stroke();
        ctx.restore();
      }
    },
  };

  const plugins = [lineToolTip];
  const data = {
    labels,
    datasets: [
      {
        label: "Profit ",
        data: profit.slice(0, -1),
        borderColor: "#5887DE",
        /* "#5887DE" */
        backgroundColor: (ctx) => {
          const chart = ctx.chart;
          const area = chart.chartArea;
          if (!area) {
            // before first draw, fallback to a solid color
            return "rgba(88, 135, 222, 0.4)";
          }
          const { top, bottom } = area;
          const grad = chart.ctx.createLinearGradient(0, top, 0, bottom);
          grad.addColorStop(0, "rgba(88, 135, 222, 0.2)");
          grad.addColorStop(1, "rgba(88, 135, 222, 0)");
          return grad;
        },
        tension: 0.25,
        borderWidth: 1.4,
        pointRadius: 0.5,
        fill: true,
      },
      {
        label: "Expense ",
        data: expenses.slice(0, -1),
        borderColor: "#ff8080",
        backgroundColor: "#ff8080",
        tension: 0.3,
        borderWidth: 1.4,
        pointRadius: 0,
      },
    ],
  };

  return (
    <div className='line-chartDashb'>
      <Line height={256} data={data} options={options} />
    </div>
  );
};

export default DashboardLineChart;
